var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2D6CE6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 1c.553 0 1 .448 1 1v3h4c.553 0 1 .448 1 1s-.447 1-1 1h-1v12c0 1.654-1.346 3-3 3H8c-1.654 0-3-1.346-3-3V7H4c-.553 0-1-.448-1-1s.447-1 1-1h4V2c0-.552.447-1 1-1zm2 6H7v12c0 .551.448 1 1 1h9c.552 0 1-.449 1-1V7zm-8 2c.553 0 1 .448 1 1v7c0 .552-.447 1-1 1-.553 0-1-.448-1-1v-7c0-.552.447-1 1-1zm5 0c.553 0 1 .448 1 1v7c0 .552-.447 1-1 1-.553 0-1-.448-1-1v-7c0-.552.447-1 1-1zm0-6h-5v2h5V3z",
    transform: "translate(-709.000000, -216.000000) translate(693.000000, 208.000000) translate(16.000000, 8.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1a312e2de21dbd063fb4e002ee8ca716.svg";
export { ForwardRef as ReactComponent };